import theme from '@/utils/theme'
export default function applySnapshot(stores, snapshot) {
  Object.assign(stores.appStore.state, snapshot.appState)
  stores.appStore.state.theme = { ...theme, ...stores.appStore.state.theme }
}
